import React from 'react'
import C from '../Const'
import {
  PolarAngleAxis,
  PolarGrid,
  PolarRadiusAxis,
  Radar,
  RadarChart,
  ResponsiveContainer,
  Tooltip,
} from '../recharts'
import U from '../Utils'

function ChartAssunzPerContr(props) {
  const { series, data, print } = props
  const { assunz_per_contr } = data

  const colors = series.length > 1 ? [C.BLUE, C.RED] : [C.YELLOW]

  const sortedSeries = series.slice()
  sortedSeries.forEach((ser, i) => (ser.i = i))
  sortedSeries.sort(
    (a, b) =>
      assunz_per_contr.reduce((sum, d) => sum + d['val' + b.suf], 0) -
      assunz_per_contr.reduce((sum, d) => sum + d['val' + a.suf], 0),
  )

  return (
    <ResponsiveContainer aspect={C.ASPECT} className="ChartAssunzPerContr">
      <RadarChart data={assunz_per_contr} startAngle={90} endAngle={-270}>
        <PolarGrid />
        <PolarAngleAxis dataKey="lbl" />
        <PolarRadiusAxis
          angle={90}
          scale="sqrt"
          axisLine={false}
          tickFormatter={(s) => (s === 0 ? '' : '__________ ' + U.formatNumber(s))}
        />
        <Tooltip formatter={U.formatNumber} />
        {sortedSeries.map((ser) => (
          <Radar
            key={ser.i}
            dataKey={'val' + ser.suf}
            stroke={colors[ser.i]}
            fill={colors[ser.i]}
            fillOpacity={0.6}
            name={'Assunzioni ' + ser.name}
            isAnimationActive={!print}
          />
        ))}
      </RadarChart>
    </ResponsiveContainer>
  )
}

export default ChartAssunzPerContr



// WEBPACK FOOTER //
// ./src/main/ChartAssunzPerContr.js